import DepressionAssessment from './DepressionAssessment';

export default DepressionAssessment;
